import React, { useState } from 'react'
import CustomAlert from '../../events/components/CustomAlert'
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography, getContrastRatio } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { updateReviewState } from '../../../redux/reviewSlice'
import CheckIcon from "../../../components/icons/CheckIcon";
import { LoadingButton } from "@mui/lab";
import "@fontsource/rubik";
import { useMutation } from 'react-query'
import { acceptFinalVideo } from '../../../services/api'
import useAcceptFinalVideo from '../hooks/useAcceptFinalVideo'
import useCustomTheme from '../../../theme/useCustomTheme'
import { generateLighterContrastColor } from '../../../utils/commonServices'
import CustomButton from '../../../components/CustomButton'



const AcceptVideoPopup = (props) => {
    const {open, acceptRequest, status} = props;
    const dispatch = useDispatch()
    const reviewEventReducer = useSelector((state)=>state.reviewEventReducer)
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const [theme ] = useCustomTheme()
    const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

    const handleClose = () => {
        dispatch(updateReviewState({open_video_accept_popup : false}))    
       };



    const acceptVideoHandler =()=>{
        // send api req to accept video
        if(commonReducer?.event_details?.sent_for_approval == false || commonReducer?.event_details?.sent_for_approval == null){
          checked &&  acceptRequest({final_video_id: commonReducer.event_details?.final_video_id}) 
        }else{
          acceptRequest({final_video_id: commonReducer.event_details?.final_video_id})    
        }
        // dispatch(updateReviewState({open_video_accept_popup : false})) 
    }

    // console.log(commonReducer?.event_details?.sent_for_approval, 'sent for approallllllllllllllll')

    return (
    
        <CustomAlert 
          open={open} 
          handleClose={handleClose} 
          width={{xs:'450px',sm:'450px',md:'470px',lg:'490px', xl:'650px'}}
          height={{xs:'370px',sm:'350px',md:'360px',lg:'390px', xl:'480px'}}
        >
           <Box p={5} className="flex col" sx={{justifyContent:'space-evenly', height:'100%'}}>
          
            <Box   mb={{xs:1 ,md:2}} sx={{gap:1, display:'flex',pr:2, flexDirection:'column'}}>
             <Typography variant="h4" sx={{fontFamily:'Rubik', fontSize:{xs:'18px',sm:'18px',md:'18px',lg:'20px',xl:'24px'}, color:'black', fontWeight:600, mb:1}}>Final Approval </Typography>

             {commonReducer?.event_details?.sent_for_approval == true && <Typography variant="h4" sx={{textAlign: 'justify', fontFamily:'Rubik', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>You're confirming that this video is complete and ready for release. </Typography>}

               <Typography variant="h4" sx={{fontFamily:'Rubik', textAlign: 'justify', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>Proceeding will close the project and make the final video available for download. </Typography>
                <Typography variant="h4" sx={{fontFamily:'Rubik', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>Are you ready to finalize? </Typography>
            </Box>

            {(commonReducer?.event_details?.sent_for_approval == false || commonReducer?.event_details?.sent_for_approval == null) && <Box   mb={{xs:1 }}>
                <FormGroup>
                     <FormControlLabel  
                     checked={checked}
                     onChange={handleChange} 
                    //  required 
                     control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: {xs:24,lg:28,xl:36} } }}/>} 
                        sx={{
      alignItems: 'flex-start', // Align checkbox to the top
      
    
    }}
                    label={<Typography  sx={{fontFamily:'Rubik', textAlign: 'justify', fontSize:{xs:'13px',sm:'13px',md:'13px',lg:'13px',xl:'18px'}, color:'black'}}>I acknowledge this video hasn’t been submitted for final approval, but I’m choosing to approve it now.</Typography>}
                    //  label="I acknowledge this video hasn’t been submitted for final approval, but I’m choosing to approve it now"
                      />

                </FormGroup>
            </Box>}
    
            <Box sx={{display:'flex',justifyContent:'end' }} gap={2} mt={{xs:1 ,md:3}} >
    
              {/* <Button variant='outlined' onClick={acceptVideoHandler} style={{borderRadius: '5px', backgroundColor:'#08231B', color:theme.palette.primary.main, textTransform:'none', }} sx={{fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'90px',sm:'100px',md:'100px',lg:'120px',xl:'150px'}, paddingY:0.4,}}>Accept Video</Button> */}

              {/* { createEventStatus == 'loading' || createEventStatus == 'success' ? <LoadingButton
                   // size="small"
                    sx={{
                        '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },
                        height: {xs:'36px',sm:'40px',md:'45px', lg:'51px',xl:'75px'},
                       minWidth: {xs:'36px !important',sm:'40px !important',md:'45px !important', lg:'51px !important',xl:'75px !important'},
                        backgroundColor: '#08231B'
                    }}
                    loading={createEventStatus == 'loading'}
                    variant="outlined"
                    disabled
                    >
                   
               </LoadingButton> : */}
               {/* <CheckIcon 
               color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} 
               onClick= {acceptVideoHandler}  
               sx={{fontSize:{xs:'300px',sm:'30px',md:'40px', lg:'42px',xl:'65px'}, cursor: commonReducer?.event_details?.sent_for_approval ? 'pointer' : checked && 'pointer', opacity: commonReducer?.event_details?.sent_for_approval == false &&  !checked && 0.5}}/> */}
                       <Button 
                                 variant="text"
                                 color='secondary'
                                 onClick={handleClose}
                                 sx={{fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'22px',sm:'22px',md:'22px',lg:'28px',xl:"35px"}, width:'20%', fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                                 >
                                     Cancel
                                 </Button> 
               {/* <CustomButton 
                                disabled={commonReducer?.event_details?.sent_for_approval == false && !checked} 
                                btnText={'Yes, Finalize & Close'}
                                variant='contained' 
                                onClick= {acceptVideoHandler}   
                                style={{borderRadius: '5px', textTransform:'none', }} 
                                color='button'
                                sx={{height:{xs:'16px', lg:'24px', xl:'35px'}, width:'40%', fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600, color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}}
                                /> */}

                  <LoadingButton
                   // size="small"
                    onClick= {acceptVideoHandler}   
                    disabled={((commonReducer?.event_details?.sent_for_approval == false && !checked) || (commonReducer?.event_details?.sent_for_approval == null && !checked)) } 
                     style={{borderRadius: '5px', textTransform:'none', }} 
                    sx={{ '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },height:{xs:'22px', lg:'28px', xl:'35px'}, width:'40%', fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600, color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}}
                    loading={status == 'loading'}
                    variant="contained"
                    color='button'
                    // disabled
                    >
                   Yes, Finalize & Close
               </LoadingButton>
            
            </Box>
           </Box>
        </CustomAlert>
      
  )
}

export default AcceptVideoPopup